import { __assign, __rest } from "tslib";
import * as React from "react";
import cx from "classnames";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DatePickerInput from "./DatePickerInput";
import "./DatePicker.css";
function DatePicker(_a) {
    var className = _a.className, inputProps = _a.inputProps, datePickerProps = __rest(_a, ["className", "inputProps"]);
    return (React.createElement("div", { className: cx("DatePicker", className) },
        React.createElement(ReactDatePicker, __assign({ customInput: React.createElement(DatePickerInput, { inputProps: inputProps }) }, datePickerProps))));
}
export default DatePicker;
